<template>
  <div class="stripe-wrapper">
    <div ref="card"></div>
    <div v-show="error" class="error-msg">
      <div @click="error=''" class="error-close">X</div>
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      error: null,
    };
  },
  props: {
    createIntentRoute: {
      type: String,
      required: false,
      default: "/en/_stripe/create/intend",
    },
    publishableKey: {
      type: String,
      required: false,
      default: "pk_test_0GSgPlOvoPF5R7oL992Z7xnf00PzXWui3B",
    },
  },
  mounted() {
    // Create a Stripe client.
    const stripeObject = Stripe(this.publishableKey);

    // Create an instance of Elements.
    const stripeElements = stripeObject.elements();

    // Create an instance of the card Element.
    const cardObject = stripeElements.create("card", {
      hidePostalCode: true,
      style: {
        base: {
          color: "#32325d",
          lineHeight: "18px",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      },
    });

    cardObject.mount(this.$refs.card);

    // Pass it to parent component if exists the property
    try {
      window.Stripe.createIntentRoute = this.createIntentRoute;
      window.Stripe.stripeObject = stripeObject;
      window.Stripe.stripeCardObject = cardObject;
      window.Stripe.stripeVueComponent = this;
    } catch (error) {
    }

    // Handle real-time validation errors from the card Element.
    const component = this;
    cardObject.addEventListener("change", function (event) {
      if (event.error) {
        component.error = event.error.message;
      } else {
        component.error = null;
      }
    });
  },
};
</script>

<style lang="scss">
  .error-msg{
    .error-close{
      position: absolute;
      top: 3px;
      right: 3px;
      color: #fff;
      cursor: pointer;
      font-weight: 600;
    }
  }
</style>